const initialState = {
    leadsStatuses: false,
    leadsStatusesFetch: false,
    reportSummary: false,
    reportConversion: false,
    leads: false,
    journal: false,
};

export default function downloading(state = initialState, action) {
    switch (action.type) {
        case 'SET_DOWNLOADING_LEADS_STATUSES':
            return {
                ...state,
                leadsStatuses: action.value
            };
        case 'SET_DOWNLOADING_LEADS_STATUSES_FETCH':
            return {
                ...state,
                leadsStatusesFetch: action.value,
            };
        case 'SET_DOWNLOADING_REPORT_SUMMARY':
            return {
                ...state,
                reportSummary: action.value
            };
        case 'SET_DOWNLOADING_REPORT_CONVERSION':
            return {
                ...state,
                reportConversion: action.value
            };
        case 'SET_DOWNLOADING_LEADS':
            return {
                ...state,
                leads: action.value
            };
        case 'SET_DOWNLOADING_JOURNAL':
            return {
                ...state,
                journal: action.value,
            };
        default:
            return state;
    }
}
